import { render, staticRenderFns } from "./DirForm.vue?vue&type=template&id=326b2a3c&scoped=true&"
import script from "./DirForm.vue?vue&type=script&lang=js&"
export * from "./DirForm.vue?vue&type=script&lang=js&"
import style0 from "./DirForm.vue?vue&type=style&index=0&id=326b2a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b2a3c",
  null
  
)

export default component.exports